var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlob1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mask",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "4in",
    height: "4in",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "center",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,100,0)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255,0,255,0)",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "green",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46e6f4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00fffc",
    offset: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(200,0,100,0)",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "left",
    xlinkHref: "#center",
    fx: "5%"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "left-up",
    xlinkHref: "#left",
    cy: "50%"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "right",
    xlinkHref: "#green",
    fx: "95%"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "right-up",
    xlinkHref: "#right",
    cy: "50%"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "r",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "r2",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "goo"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 20,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "goo",
    operator: "atop"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    id: "goo1",
    xlinkHref: "#r",
    x: "0%",
    y: "0%",
    fill: "url(#left-up)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "goo2",
    xlinkHref: "#r2",
    x: "0%",
    y: "0%",
    fill: "url(#right-up)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob1);
export default __webpack_public_path__ + "static/media/blob1.a289d478e4bc8f7660f7d0fbdd13004e.svg";
export { ForwardRef as ReactComponent };